export default __webpack_public_path__ + "edc4de564fa40c379b125841bbeae5e1.png";